(() => {
  const root = document.querySelector('.shopify-policy__container');
  if (!root || root.dataset.galriePolicy) return;
  const body = root.querySelector('.shopify-policy__body .rte');
  if (!body) return;
  root.dataset.galriePolicy = 'true';
  const sections = new Set(['Our Commitment','Estimated Delivery Times','Please Note','Policy Highlights','Non-Returnable Items','Contact Us','Damaged or Faulty Items','Change of Mind','Incorrect Orders','Cancellations','Process for Returns','Customer Satisfaction']);
  const subheads = new Set(['United States, Australia, United Kingdom and Europe','Rest of World']);
  [...body.children].forEach(el => {
    const text = el.textContent.trim();
    if (el.tagName === 'P' && !text) { el.remove(); return; }
    if (el.tagName === 'P' && (sections.has(text) || subheads.has(text))) {
      const h = document.createElement(subheads.has(text) ? 'h3' : 'h2');
      h.textContent = text; el.replaceWith(h);
    }
  });
  const headings = [...body.querySelectorAll('h2')];
  if (!headings.length) return;
  const nav = document.createElement('nav');
  nav.className = 'galrie-policy-nav'; nav.setAttribute('aria-label','On this page');
  const label = document.createElement('p'); label.textContent = 'On this page'; nav.append(label);
  headings.forEach((h,i) => {
    if (!h.id) h.id = `policy-section-${i+1}`;
    const link = document.createElement('a'); link.href = '#'+h.id; link.textContent=h.textContent; nav.append(link);
  });
  root.querySelector('.shopify-policy__body').before(nav);
  body.querySelectorAll('a[href="/pages/contact"]').forEach(a => a.href='/pages/contact-us');
})();
